<template>
  <div class="notice-feedback min-height padding">
    <div class="flex align-center justify-between margin-bottom">
      <div class="flex align-center">
        <el-input placeholder="请输入机构名称" v-model="searchName"></el-input>

        <el-select
          v-model="feedback"
          placeholder="请选择反馈情况"
          class="margin-left-sm"
          style="width: 300px"
        >
          <el-option
            v-for="item in feedbackList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-button type="primary" class="margin-left-sm" @click="search"
          >搜索</el-button
        >
      </div>
      <div class="flex align-center">
        <span class="font-size-lg">未反馈：{{ no_reply_num }} </span>
        <i class="padding-left"></i>
        <span class="font-size-lg"> 已反馈：{{ reply_num }}</span>
      </div>
    </div>
    <el-table
      :data="tableData"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="company_name" label="机构名称" width="200">
      </el-table-column>
      <el-table-column prop="reply_status" label="反馈状态" width="100">
        <template slot-scope="scope">
          {{ scope.row.reply_status === 0 ? "未反馈" : "已反馈" }}
        </template>
      </el-table-column>
      <el-table-column prop="reply_content" label="反馈内容"> </el-table-column>
      <el-table-column label="反馈附件" width="100px">
        <template slot-scope="scope">
          <el-link
            :href="scope.row.reply_attache_file.url"
            target="_blank"
            :underline="false"
            v-if="scope.row.reply_attache_file"
          >
            <el-button type="text" class="font-size-sm"> 附件下载 </el-button>
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.length > 0"
      class="page-all"
      background
      @current-change="getList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { noticeReplyQueryManage } from '@/api/admin'
import { feedbackList } from "@/utils/utils";
export default {
  name: "noticeFeedback",
  data () {
    return {
      searchName: '',
      feedbackList: feedbackList,
      feedback: 0,
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      no_reply_num: 0,
      reply_num: 0,
    }
  },
  created () {
    this.$emit("setIndex", '/admin/noticeDetail', "通知公告  /  反馈信息", true, 'icon-gonggao');
    this.getList()
  },
  components: {},
  methods: {
    //  搜索
    search () {
      this.page = 1
      this.getList()
    },
    //    获取列表
    async getList () {
      let _list = await noticeReplyQueryManage(this.$route.params.id, this.searchName, this.page, this.limit,this.feedback)
      _list.data.list.data.map(item => {
        if (item.reply_attache_file) item.reply_attache_file = JSON.parse(item.reply_attache_file)
      })
      this.tableData = _list.data.list.data
      this.total = _list.data.list.total
      this.no_reply_num = _list.data.noticeInfo.no_reply_num
      this.reply_num = _list.data.noticeInfo.reply_num
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
</style>